/**
 * Минимальная версия CSElement для тестирования
 */

import { CSElement } from './core/CSElement';
import { EventEmitter } from 'eventemitter3';

// Основной класс
export { CSElement };
export default CSElement;

// EventEmitter для совместимости
export { EventEmitter };

// Базовые типы
export {
  ElementEventType
} from './types/interfaces';

// Утилиты
export { generateId } from './utils/helpers'; 